import type { SVGProps } from "react";

export function Home4(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 19"
      fill="none"
      {...props}
    >
      <path
        opacity="0.4"
        d="M9 1.4375C8.35043 1.4375 7.76978 1.64516 7.14286 1.99695C6.53543 2.33782 5.8394 2.84109 4.96415 3.47393L3.83238 4.29224C3.12998 4.8001 2.56896 5.20572 2.14582 5.58115C1.70891 5.9688 1.38206 6.35525 1.17473 6.84135C0.966938 7.32852 0.916688 7.82784 0.944558 8.40357C0.971461 8.95918 1.07448 9.62953 1.20295 10.4654L1.43939 12.004C1.62192 13.1919 1.76726 14.1377 1.98079 14.8747C2.20158 15.6366 2.51262 16.2415 3.06855 16.7039C3.62218 17.1644 4.28168 17.3695 5.0873 17.4673C5.871 17.5625 6.85961 17.5625 8.10833 17.5625H9.89168C11.1404 17.5625 12.129 17.5625 12.9127 17.4673C13.7183 17.3695 14.3778 17.1644 14.9315 16.7039C15.4874 16.2415 15.7985 15.6366 16.0193 14.8747C16.2328 14.1378 16.3781 13.1919 16.5606 12.004L16.7971 10.4653C16.9256 9.62945 17.0285 8.95918 17.0555 8.40357C17.0834 7.82784 17.0331 7.32852 16.8253 6.84135C16.618 6.35525 16.2911 5.9688 15.8542 5.58115C15.431 5.20572 14.87 4.8001 14.1677 4.29225L13.0358 3.47394C12.1607 2.84109 11.4646 2.33782 10.8572 1.99695C10.2302 1.64516 9.64958 1.4375 9 1.4375Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 14C6.75 13.5858 7.08579 13.25 7.5 13.25H10.5C10.9142 13.25 11.25 13.5858 11.25 14C11.25 14.4142 10.9142 14.75 10.5 14.75H7.5C7.08579 14.75 6.75 14.4142 6.75 14Z"
        fill="currentColor"
      />
    </svg>
  );
}
